import CheckPermission from 'components/auth/CheckPermission'
import { FormApi } from 'final-form'

import { grupoCboOrientacoes } from '../../acessos'
import { OrientacaoFormModel } from '../model-orientacoes'
import { OrientacoesForm } from './OrientacoesForm'

interface OrientacoesCadastroViewProps {
  onSubmit(formValues: OrientacaoFormModel, formApi: FormApi<OrientacaoFormModel>): void
  onFocus(): void
}

export function OrientacoesCadastroView(props: OrientacoesCadastroViewProps) {
  const { onSubmit, onFocus } = props

  return (
    <CheckPermission permission={grupoCboOrientacoes.adicionar}>
      <OrientacoesForm onSubmit={onSubmit} onFocus={onFocus} showAlerts />
    </CheckPermission>
  )
}
